import { createBrowserHistory } from 'history';

let userConfirmAction = () => {};

export function resolveBasename() {
  const parts = location.pathname.split('/');
  return `/${parts[1]}/${parts[2]}`;
}

const resolvedBasename = resolveBasename();

export function getBasename() { return resolvedBasename }

export const browserHistory = createBrowserHistory({
  getUserConfirmation: (msg, cb) => userConfirmAction(msg, cb),
  basename: resolvedBasename
});

export function setUserConfirmAction(cb) {
  userConfirmAction = cb;
}
